package com.castly.admin.dto

import kotlinx.serialization.Serializable

/**
 * Video metadata for episodes with video content (Feature 014)
 * Simplified schema per API standardization - clients receive video URLs directly
 *
 * Frontend copy (Kotlin/JS compatible)
 */
@Serializable
data class VideoObject(
    val id: String,             // Video identifier
    val url: String,            // CloudFront signed URL for video
    val provider: String? = null       // e.g., "youtube", "vimeo", null for direct hosting
)
